/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 04-10-2020.
 */
import React, { useRef, useState } from 'react'
import { navigate } from 'gatsby-link'
import Spinner from '../spinner/Spinner'
import './upload-form.scss'
import ErrorMessage from './ErrorMessage'
import { win } from '../../utils/browserMock'
import CheckMark from '../../assets/check_black.svg'
import { sendToDataLayer } from '../../DataLayer'

import { graphql, useStaticQuery } from 'gatsby'
import useOnClickOutside from 'use-onclickoutside'

const OFFER_TYPE = ['Overslagspris – ca 2 hverdage.', 'Tilbud – ca 5-7 hverdage.']
const MATERIALS_ARR = ['Finér', 'Linoleum', 'Malet', 'Laminat']
const DRAWER_ARR = ['Skuffer - ja tak', 'Nej tak']

const emptyErrorObj = { name: '', phone: '', email: '', file: '', permission: '', message: '', offer: '' }

const NetlifyForm = ({ fileRequired = true }) => {
  const { models } = useStaticQuery(
    graphql`
      query {
        models: allMetodProductsJson {
          edges {
            node {
              id
              name
              type
              icon {
                publicURL
              }
            }
          }
        }
      }
    `
  )

  const allProducts = models.edges

  const [state, setState] = React.useState({
    permission: false,
    name: '',
    phone: '',
    email: '',
    file: '',
    mat: '',
    drawer: '',
    models: '',
    mounting: '',
    offer: -1,
    tabelTop: '',
    utm_campaign: '',
    utm_content: '',
    utm_medium: '',
    utm_source: '',
    postal: '',
    city: '',
    location: '',
  })

  const [loading, setLoading] = useState()
  const [fileName, setFileName] = useState('')
  const [error, setError] = useState(emptyErrorObj)

  //const [selectedModel, setSelectedModel] = useState([false, false, false, false, false, false, false, false, false])
  const [selectedModelBuffer, setSelectedModelBuffer] = useState([-1, -1])
  const [selectedMaterial, setSelectedMaterial] = useState([false, false, false])
  const [selectDrawer, setSelectDrawer] = useState(-1)
  const [selectMount, setSelectedMounting] = useState(-1)
  const [selectTabelTop, setSelectTabelTop] = useState(-1)
  const [selectedOffertype, setSelectedOffertype] = useState(-1)

  const encode = (data) => {
    const formData = new FormData()
    for (const key of Object.keys(data)) {
      formData.append(key, data[key])
    }
    return formData
  }

  const handleChange = (e) => {
    const key = e.target.name
    if (error[key]) {
      console.log('NetlifyForm > error[] = ')
      setError({ ...error, [key]: '' })
    }

    setState({ ...state, [e.target.name]: e.target.value })
  }

  const handleAttachment = (e) => {
    const fileName = e.target.files[0] && e.target.files[0].name
    setFileName(fileName)
    setError({ ...error, file: '' })
    setState({ ...state, [e.target.name]: e.target.files[0] })
  }

  /*  useEffect(() => {
    const strObj = win.localStorage.getItem('myform')
    const utmObj = getUtm()

    const json = JSON.parse(strObj)

    const locationObj = getLocationObj()
    const city = locationObj.city || 'not detected'

    const postal = locationObj.postal || 'not detected'
    const locObj = {
      country_code: locationObj.country_code || '',
      ip: locationObj.ip || '',
      latitude: locationObj.latitude || '',
      longitude: locationObj.longitude || '',
      region: locationObj.region || '',
    }

    setState((oldState) => {
      return { ...oldState, ...json, ...utmObj, city: city, postal: postal, location: JSON.stringify(locObj) }
    })
  }, [])*/

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  // Usage
  //const email = 'test@example.com'

  const handleSubmit = (e) => {
    e.preventDefault()
    sendToDataLayer({ event: 'FORM_INIT' })
    const err = { name: '', phone: '', email: '', file: '', permission: '', message: '', offer: '' }

    if (state.email && !emailRegex.test(state.email)) {
      err.email = 'Den indtasted email er ikke gyldig'
    }

    // validate file is selected
    /*if (!fileName && fileRequired) {
      err.file = 'Husk at upload din IKEA tegning'
    }*/

    // validate phone
    if (!state.phone) {
      err.phone = 'Husk at indtaste dit telefon nr.'
    }

    // validate email
    if (!state.name) {
      err.name = 'Venligst oplys dit navn'
    }

    // validate email
    if (!state.email) {
      err.email = 'Vi skal bruge din email for at kunne svare.'
    }

    if (!state.message) {
      err.message = 'Skriv et par ord om dine ønsker og behov'
    }

    console.log('NetlifyForm > state.offer = ', state.offer)
    if (state.offer === -1) {
      err.offer = 'Vælg venligst en tilbudstype for at fortsætte.'
    }

    if (!state.permission) {
      err.permission = 'Vi har brug for at kunne komme i kontakt med dig.'
    }

    console.log(' NetlifyForm > state = ', state)
    // we dont if name is missing
    if (err.email || err.phone || err.file || err.message || err.permission || err.offer) {
      setError(err)
      console.log(' NetlifyForm > error STOP = ', err)
      return
    }

    setLoading(true)
    setError(err)

    const form = e.target
    win.localStorage.setItem('myform', JSON.stringify({ name: state.name, email: state.email, phone: state.phone }))

    const dataObj = {
      ...state,
      drawer: selectDrawer === -1 || selectDrawer === 1 ? 'Ingen skuffer' : 'Skuffer - ja tak',
      mounting: selectMount === -1 || selectMount === 1 ? 'Ingen montering' : 'Montering - ja tak',
      offer: selectedOffertype === 0 ? OFFER_TYPE[0] : OFFER_TYPE[1],
    }

    console.log('NetlifyForm > dataObj = ', dataObj)

    fetch('/', {
      method: 'POST',
      body: encode({
        'form-name': form.getAttribute('name'),
        ...dataObj,
      }),
    })
      .then((res) => {
        //
        // REMEMBER !!!!
        // the res is not what is returned from the submission-created
        // thats only when testing - in production there is not anything
        //

        //
        // stop loading spinner
        //
        setLoading(false)

        //
        // validate the call was succesfull
        //
        if (!res.ok) {
          return Promise.reject(res)
        }

        //
        // if email contains test then ignore
        //
        const savedEmail = state.email || ''

        if (savedEmail.indexOf('tester') === -1) {
          sendToDataLayer({ event: 'FORM_COMPLETED' })
        } else {
          console.log(' NetlifyForm > Detected a test email address')
        }

        return navigate('/tak/')
      })
      .catch((error) => {
        console.log(' NetlifyForm > error = ', error)
        setLoading(false)
        alert(
          '\nDin besked blev ikke sendt. \n\nVi oplever i øjeblikket problemer med at modtage beskeder. Forsøg evt. at kontakte os på telefon 93 99 23 98 \nMed venlig hilsen\nHackk'
        )
      })
  }

  const togglePermission = () => {
    const updatePermission = !state.permission
    setState({ ...state, permission: updatePermission })
  }

  const modelSelectClick = (value, modelIndex) => {
    const newArr = selectedModelBuffer.concat([])

    if (value === -1) {
      const atIndex = newArr.indexOf(modelIndex)
      newArr[atIndex] = -1
    } else {
      newArr.unshift(value)
    }

    const updatedArr = newArr.slice(0, 2)

    const selectedModelIndexOne = updatedArr[0] === -1 ? '-' : allProducts[updatedArr[0]].node.name
    const selectedModelIndexTwo = updatedArr[1] === -1 ? '-' : allProducts[updatedArr[1]].node.name
    const models = selectedModelIndexOne + ' - ' + selectedModelIndexTwo

    setSelectedModelBuffer(updatedArr)

    setState({ ...state, models: models })
  }

  const materialSelectClick = (value) => {
    const newArr = selectedMaterial.concat([])
    newArr[value] = !newArr[value]
    setSelectedMaterial(newArr)
    const mat = newArr
      .map((mat, index) => {
        return mat === true ? MATERIALS_ARR[index] : ' '
      })
      .toString()
    setState({ ...state, mat: mat })
  }

  const drawerSelectClick = (value) => {
    /*const newArr = selectedMaterial.concat([])
    newArr[value] = !newArr[value]*/
    setSelectDrawer(value)

    setState({ ...state, drawer: value })
  }

  const offerSelectClick = (value) => {
    console.log('NetlifyForm > clikker = ')
    setSelectedOffertype(value)
    setError(emptyErrorObj)
    setState({ ...state, offer: value })
  }

  const mountingSelectClick = (value) => {
    /*const newArr = selectedMaterial.concat([])
    newArr[value] = !newArr[value]*/
    setSelectedMounting(value)

    setState({ ...state, mounting: value })
  }

  const tabelTopSelectClick = (value) => {
    setSelectTabelTop(value)
    setState({ ...state, tabelTop: value })
  }

  const handleKeyDown = (ev) => {
    // check keys if you want
    if (ev.keyCode === 13) {
    }
  }

  return (
    <div className="row hackk-form" style={{}}>
      <div className="col-12 col-md-10 mx-auto">
        <form
          name="file-upload"
          method="post"
          action="/thanks/"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
        >
          <div className="row">
            {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
            <input type="hidden" name="form-name" value="file-upload" />
            <p hidden>
              <label>
                Don’t fill this out: <input name="bot-field" onChange={handleChange} />
              </label>
            </p>
            <div className="col-12 mb-2">
              <label className="w-100 mb-1">
                <p className="mb-1 p-small ">Din email adresse:</p>
                <input
                  placeholder="Jens@jensen.dk"
                  className={'w-100 field ' + (error.email ? 'border-danger' : '')}
                  /*type="email"*/
                  name="email"
                  value={state.email}
                  onChange={handleChange}
                />
              </label>
              <ErrorMessage errorKey="email" error={error}></ErrorMessage>
            </div>
            <div className="col-12 col-md-6 pr-md-2 mb-2">
              <label className="w-100 mb-1">
                <p className="mb-1 p-small">Dit navn:</p>
                <input
                  className={'w-100 field ' + (error.name ? 'border-danger' : '')}
                  type="name"
                  placeholder="Jens jensen"
                  name="name"
                  value={state.name}
                  onChange={handleChange}
                />
              </label>
              <ErrorMessage errorKey="name" error={error}></ErrorMessage>
            </div>
            <div className="col-12 col-md-6 pl-md-2 mb-2">
              <label className="w-100 mb-1">
                <p className="mb-1 p-small">Dit telefon nr:</p>
                <input
                  className={'w-100 field ' + (error.phone ? 'border-danger' : '')}
                  placeholder="22 21 22 21"
                  type="number"
                  name="phone"
                  onChange={handleChange}
                  value={state.phone}
                />
              </label>
              <ErrorMessage errorKey="phone" error={error}></ErrorMessage>
            </div>
            <div className="col-12">
              <label className="w-100 ">
                <p className="mb-1 p-small">Din besked</p>
                <textarea
                  onChange={handleChange}
                  type="text"
                  name="message"
                  className={'w-100 field ' + (error.message ? 'border-danger' : '')}
                  placeholder="Din besked"
                  rows={4}
                  cols={5}
                  style={{
                    fontStyle: 'italic',
                    color: '#4e4e4e',
                    background: 'white',
                  }}
                />
              </label>
              <ErrorMessage errorKey="message" error={error}></ErrorMessage>
            </div>
            <div className="col-12 my-3 h-100">
              <div className="d-flex align-items-center">
                <LabelField label="Tilbudstype" postfix=""></LabelField>
                <div className="mb-2 d-inline-block ms-1" style={{ background: '#323232', transform: 'rotate(-1deg)' }}>
                  <p className="p-small fw-semibold py-1 px-2 shadow-sm text-white">
                    Hurtig overslagspris eller 3D tegninger
                  </p>
                </div>
              </div>

              <p className="p-small mb-2 ms-1 ">
                Vi oplever heldigvis stor interesse fra kunder på vores produkter og løsninger. For at kunne give den
                bedste service til alle interesserede, tilbyder vi nu to forskellige muligheder for at modtage et tilbud
                fra Hackk.
              </p>
              <div className="mt-2 d-flex justify-content-around h-100">
                {OFFER_TYPE.map((item, offerIndex) => {
                  //const isSelected = selectedOffertype[offerIndex] ? true : false
                  const isSelected = offerIndex === selectedOffertype
                  return (
                    <div
                      key={offerIndex}
                      className="px-1 w-100 pointer  "
                      onClick={() => {
                        offerSelectClick(offerIndex)
                      }}
                      role="button"
                      tabIndex={0}
                      onKeyDown={handleKeyDown}
                    >
                      <div
                        className="noselect w-100 d-flex flex-column h-100 py-5
                         align-items-center justify-content-center position-relative "
                        style={{
                          background: isSelected ? '#ffffff' : '#ffffff',
                          minHeight: 100,
                          borderRadius: 4,
                          border: isSelected ? '1px solid rgba(0,0,0,.6)' : '1px solid rgba(0,0,0,.3)',
                          boxShadow: isSelected
                            ? '0px 3px 10px -1px rgba(0, 0, 0, .25)'
                            : '0px 7px 8px -4px rgba(0, 0, 0, 0)',
                          //boxShadow: '0px 3px 10px -2px rgba(0, 0, 0, .15)',
                        }}
                      >
                        {isSelected ? (
                          /*<img className="ml-2" style={{ width: '1.5rem', height: 'auto' }} src={checkSvg} alt="" />*/
                          <CheckMark
                            className="ms-1 mb-1 text-center position-absolute"
                            style={{ top: 3, right: 3 }}
                          ></CheckMark>
                        ) : null}

                        <p
                          className="mb-0 font-weight-bold noselect text-center px-4 px-md-0"
                          style={{ opacity: isSelected || selectedOffertype === -1 ? 1 : 0.5 }}
                        >
                          {item}
                        </p>
                        {offerIndex === 0 && isSelected ? (
                          <p className="p-small p-4">
                            Men denne mulighed får du en hurtig pris tilsendt. Hvis du derefter ønsker at modtage et
                            mere komplet tilbud med tegninger etc, så tages dette i runde 2.
                          </p>
                        ) : null}
                        {offerIndex === 1 && isSelected ? (
                          <p className="p-small p-4">
                            Du vil modtage et komplet tilbud med opstalter, 3D visualiseringer etc, der skal danne
                            grundlag for dit fremtidige køkken.
                          </p>
                        ) : null}
                      </div>
                    </div>
                  )
                })}
              </div>
              <div className="d-flex justify-content-center">
                <ErrorMessage errorKey="offer" error={error}></ErrorMessage>
              </div>
            </div>
            <div className="col-12 mt-3 ">
              <LabelField label="Vælg model" postfix=""></LabelField>

              <div className="d-flex flex-wrap flex-md-nowrap justify-content-center justify-content-between pb-4">
                {allProducts.map((item, modelIndex) => {
                  const isSelected = selectedModelBuffer.indexOf(modelIndex) !== -1
                  return (
                    <ModelItem
                      key={modelIndex}
                      index={modelIndex}
                      node={item.node}
                      isSelected={isSelected}
                      modelClick={modelSelectClick}
                    ></ModelItem>
                  )
                })}
              </div>
            </div>

            <div className="col-12 mt-1 mb-4  ">
              <div className="ms-1">
                <LabelField label="Snedkerskuffer i massivt egetræ" postfix="(valgfrit)"></LabelField>
              </div>
              <p className="p-small mb-2 ms-1 ">
                Ønsker du tilbud på skuffer? Vi tilbyder Snedkerskuffer i massivt egetræ til både køkken og garderobe
              </p>
              <div className="d-flex justify-content-around ">
                {DRAWER_ARR.map((item, drawerIndex) => {
                  const isSelected = drawerIndex === selectDrawer
                  return (
                    <div
                      key={drawerIndex}
                      className="px-1 w-100 pointer position-relative"
                      onClick={() => {
                        drawerSelectClick(drawerIndex)
                      }}
                      role="button"
                      tabIndex={0}
                      onKeyDown={handleKeyDown}
                    >
                      <div
                        className="noselect w-100 d-flex flex-column align-items-center justify-content-center position-relative"
                        style={{
                          background: '#ffffff',
                          minHeight: 100,
                          borderRadius: 4,
                          border: isSelected ? '1px solid rgba(0,0,0,.6)' : '1px solid rgba(0,0,0,.4)',
                          boxShadow: isSelected
                            ? '0px 3px 10px -1px rgba(0, 0, 0, .25)'
                            : '0px 7px 8px -4px rgba(0, 0, 0, 0)',
                        }}
                      >
                        {isSelected ? (
                          <CheckMark
                            className="ms-1 mb-1 text-center position-absolute"
                            style={{ top: 3, right: 3 }}
                          ></CheckMark>
                        ) : null}
                        <p
                          className="mb-0 text-center font-weight-bold noselect"
                          style={{ opacity: isSelected || selectDrawer === -1 ? 1 : 0.5 }}
                        >
                          {item}
                        </p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>

            <div className="col-12 mt-2 ">
              <LabelField label="Vælg materiale" postfix=""></LabelField>
              <div className="mt-2 d-flex justify-content-around ">
                {MATERIALS_ARR.map((item, materialIndex) => {
                  const isSelected = selectedMaterial[materialIndex] ? true : false
                  return (
                    <div
                      key={materialIndex}
                      className="px-1 w-100 pointer position-relative"
                      onClick={() => {
                        materialSelectClick(materialIndex)
                      }}
                      role="button"
                      tabIndex={0}
                      onKeyDown={handleKeyDown}
                    >
                      <div
                        className="noselect w-100 d-flex flex-column align-items-center justify-content-center position-relative"
                        style={{
                          background: isSelected ? '#ffffff' : '#ffffff',
                          minHeight: 100,
                          borderRadius: 4,
                          border: isSelected ? '1px solid rgba(0,0,0,.6)' : '1px solid rgba(0,0,0,.4)',
                          boxShadow: isSelected
                            ? '0px 3px 10px -1px rgba(0, 0, 0, .25)'
                            : '0px 7px 8px -4px rgba(0, 0, 0, 0)',
                          //boxShadow: '0px 3px 10px -2px rgba(0, 0, 0, .15)',
                        }}
                      >
                        {isSelected ? (
                          /*<img className="ml-2" style={{ width: '1.5rem', height: 'auto' }} src={checkSvg} alt="" />*/
                          <CheckMark
                            className="ms-1 mb-1 text-center position-absolute"
                            style={{ top: 3, right: 3 }}
                          ></CheckMark>
                        ) : null}
                        <p className="mb-0  font-weight-bold noselect">{item}</p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>

            <div className="col-12 mt-5 mb-4 ">
              <div className="d-flex align-items-center">
                <LabelField label="Bordplade" postfix="(valgfrit)"></LabelField>
                <div className="mb-2 d-inline-block ms-1" style={{ background: '#f1d906', transform: 'rotate(-1deg)' }}>
                  <p className="p-small fw-semibold py-1 px-2 shadow-sm">20% rabat på alle bordplader</p>
                </div>
              </div>
              <div className="mb-2">
                <p className="p-small  ">
                  Ønsker du tilbud på bordplade ? Vi har et bredt udvalg af bordplader samt vaske til dit køkken. I
                  vores showroom kan du se prøver på mange af vores bordplader.
                  <br />
                  Kender du allerede den type samt model bordplade du ønsker, kan du skrive det i tekstfeltet foroven.
                  Alternativt kan du vælge den type bordplade du ønsker i menuen herunder.
                </p>
              </div>
              <TabelDropDown tabelTopSelectClick={tabelTopSelectClick}></TabelDropDown>
            </div>

            <div className="col-12 mt-2 ">
              <LabelField label="Montering:" postfix="(valgfrit)"></LabelField>
              <p className="p-small mb-3">
                Ønsker du tilbud på montering af dit projekt? Gennem vores samarbejdspartner, tilbyder vi montering af
                dit projekt. Har du brug for andre opgaver såsom el, vvs etc kan de også være behjælpelige.
              </p>
              <div className="d-flex justify-content-around ">
                {['Montering - Ja tak', 'Nej tak'].map((item, mountIndex) => {
                  const isSelected = mountIndex === selectMount
                  return (
                    <div
                      key={mountIndex}
                      className="px-1 w-100 pointer position-relative"
                      onClick={() => {
                        mountingSelectClick(mountIndex)
                      }}
                      role="button"
                      tabIndex={0}
                      onKeyDown={handleKeyDown}
                    >
                      <div
                        className="noselect w-100 d-flex flex-column align-items-center justify-content-center position-relative"
                        style={{
                          background: '#ffffff',
                          minHeight: 100,
                          borderRadius: 4,
                          border: isSelected ? '1px solid rgba(0,0,0,.6)' : '1px solid rgba(0,0,0,.4)',
                          boxShadow: isSelected
                            ? '0px 3px 10px -1px rgba(0, 0, 0, .25)'
                            : '0px 7px 8px -4px rgba(0, 0, 0, 0)',
                        }}
                      >
                        {isSelected ? (
                          <CheckMark
                            className="ms-1 mb-1 text-center position-absolute"
                            style={{ top: 3, right: 3 }}
                          ></CheckMark>
                        ) : null}
                        <p
                          className="mb-0 text-center font-weight-bold noselect"
                          style={{ opacity: isSelected || selectMount === -1 ? 1 : 0.5 }}
                        >
                          {item}
                        </p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>

            <div className="col-12 mt-5">
              {!fileRequired && (
                <div>
                  <p className="mb-0 font-weight-bolder">Send os din IKEA tegning</p>
                  <p className="p-small mt-1 mb-2 font-weight-light ">Hvis du ønsker et uforpligtende tilbud.</p>
                </div>
              )}

              <label className="d-inline-block pointer w-100 mt-2">
                <input className="d-none" type="file" name="attachment" onChange={handleAttachment} />
                <div
                  className="w-100 p-5 "
                  style={{ background: '#ffffff', boxShadow: '0px 5px 12px -5px rgba(0, 0, 0, 0.2)' }}
                >
                  {fileName ? (
                    <p className="mb-0 text-center p-small">
                      <span className="text-black-50">Du valgte:</span> {fileName}
                    </p>
                  ) : (
                    <p className="mb-0 text-center ">Vælg tegning +</p>
                  )}
                </div>
              </label>
              <div className="text-center">
                <ErrorMessage errorKey="file" error={error}></ErrorMessage>
              </div>
            </div>
          </div>
          <div className="row mt-2" style={{}}>
            <div className="col-12 col-md-9 mx-auto d-flex justify-content-center py-5">
              <div
                onClick={togglePermission}
                className="pointer round me-4 position-relative "
                onKeyDown={handleKeyDown}
                tabIndex={0}
                role="button"
              >
                <div className="position-absolute" style={{ zIndex: 10 }}>
                  {state.permission ? (
                    <CheckMark
                      className="noselect "
                      style={{ pointerEvents: 'none', width: '2rem', height: '2rem' }}
                    ></CheckMark>
                  ) : (
                    <div
                      className={'bg-white rounded-circle border ' + (error.permission ? 'border-danger' : '')}
                      style={{ pointerEvents: 'none', width: '2rem', height: '2rem' }}
                    ></div>
                  )}
                </div>
                {/* <label htmlFor="checkbox">
                  <input type="checkbox" defaultChecked={state.permission} id="checkbox" />
                </label>*/}
              </div>

              <div className="ps-4 ">
                <p className="mb-0 mt-0 mt-md-1 noselect ">Må vi følge op på din henvendelse via e-mail og telefon?</p>
                <ErrorMessage errorKey="permission" error={error}></ErrorMessage>
              </div>
            </div>

            <input type="hidden" name="offer" value={state.offer} />
            <input type="hidden" name="mat" value={state.mat} />
            <input type="hidden" name="models" value={state.models} />
            <input type="hidden" name="drawer" value={state.drawer} />
            <input type="hidden" name="city" value={state.city} />
            <input type="hidden" name="postal" value={state.postal} />
            <input type="hidden" name="location" value={state.location} />
            <input type="hidden" name="mounting" value={state.mounting} />
            <input type="hidden" name="tabelTop" value={state.tabelTop} />
            {/*<input type="hidden" name="utm_content" value={state.utm_content} />
            <input type="hidden" name="utm_medium" value={state.utm_medium} />
            <input type="hidden" name="utm_source" value={state.utm_source} />
            <input type="hidden" name="utm_campaign" value={state.utm_campaign} />*/}

            <div className="col-12 col-md-12 d-flex justify-content-md-center justify-content-center mt-4 mt-md-2 mb-2">
              {loading && <Spinner></Spinner>}
              {!loading && (
                <button
                  className="rounded-pill px-md-6 py-md-3 px-7 py-4"
                  style={{ background: '#3C4043', border: 'none', color: 'white' }}
                  type="submit"
                >
                  <p className="fw-bold">Send</p>
                </button>
              )}
            </div>

            <div className="col-12 col-md-12 d-flex justify-content-md-center justify-content-center  mt-md-2 mb-5">
              <div className="">
                {/*<p className="text-center">Udfyld venligst</p>*/}
                {Object.keys(error).map((key, errIndex) => {
                  if (!error[key] || key === 'permission') {
                    return null
                  }
                  return (
                    <p key={errIndex} className="p-small text-danger">
                      - {error[key]}
                    </p>
                  )
                })}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

const LabelField = ({ label, postfix = '' }) => {
  return (
    <p className="mb-1 p-small text-black ">
      <span className="fw-semibold">{label}</span>
      {postfix ? <span className="ms-1 opacity-75"> {postfix}</span> : null}
    </p>
  )
}

const ModelItem = ({ node, modelClick, isSelected, index }) => {
  const clikker = () => {
    if (!isSelected) {
      modelClick(index)
    } else {
      modelClick(-1, index)
    }
  }

  const handleKeyDown = (ev) => {
    // check keys if you want
    if (ev.keyCode === 13) {
    }
  }

  return (
    <div onClick={clikker} className="" onKeyDown={handleKeyDown} role="button" tabIndex={0}>
      <div className="position-relative pointer px-1 px-xl-2 pt-3 pt-md-0 mt-1">
        {isSelected ? (
          <div
            className="position-absolute w-100 h-100 d-flex justify-content-center align-content-center  pt-3 pt-md-0"
            style={{
              top: 4,
              left: 0,
            }}
          >
            <CheckMark className="mt-3" style={{ width: 25, height: 25 }}></CheckMark>
            {/*<img className="" style={{ width: '1.5rem', height: 'auto' }} src={checkSvg} alt="" />*/}
          </div>
        ) : null}

        <img
          className="w-100 h-100 d-block "
          style={{
            maxHeight: 65,
            boxShadow: isSelected ? '0px 3px 10px -1px rgba(0, 0, 0, .25)' : '0px 7px 8px -4px rgba(0, 0, 0, .0)',
          }}
          src={node.icon.publicURL}
          alt=""
        />
      </div>
      <p className="mb-0 mt-1 text-center p-small">{node.name}</p>
    </div>
  )
}

export default NetlifyForm

const tabelMaterial = [
  { title: 'Komposit – Silestone' },
  { title: 'Stål – 5 mm massiv' },
  { title: 'Corian' },
  { title: 'Marmor' },
  { title: 'Granit' },
  { title: 'Keramik – Dekton' },
  { title: 'Ingen bordplade' },
]

const TabelDropDown = ({ tabelTopSelectClick }) => {
  const dropRef = useRef()
  const defaultValue = 'Vælg bordplade'
  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState(null)
  const toggleClick = () => {
    setOpen(!open)
  }

  useOnClickOutside(dropRef, () => {
    setOpen(false)
  })

  const onSelect = (tabelItem) => {
    setOpen(false)
    setSelected(tabelItem.title)
    tabelTopSelectClick(tabelItem.title)
  }

  return (
    <div className="dropdown">
      <div
        onClick={toggleClick}
        className="dropdown-toggle bg-white col-12 col-md-8 d-flex justify-content-between align-items-center p-2  "
        style={{ border: open ? '1px solid rgba(0,0,0,.6)' : '1px solid rgba(0,0,0,.4)' }}
      >
        {selected ? selected : defaultValue}
      </div>

      <div ref={dropRef} className="dropdown-menu w-100 shadow-lg" style={{ display: open ? 'block' : 'none' }}>
        {tabelMaterial.map((item, index) => {
          const classes = index === tabelMaterial.length - 1 ? 'dropdown-item opacity-75' : 'dropdown-item'

          return (
            <div
              key={index}
              onClick={() => {
                onSelect(item)
              }}
              className={classes}
            >
              {item.title ? item.title : '-'}
            </div>
          )
        })}
      </div>
    </div>
  )
}
